// Lib
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Util
import { prop } from '../../../../common/utils/immutableHelper';
import { manuallyReportError } from '../../../analytics/rollbarService';

// Actions
import { navigateToLogin } from '../../../reducers/navigationActions';
import { intercomShowMessages } from '../../../analytics/analyticsActions';

// Components
import ModalActionsList from '../../modal/ModalActionsList';

// Constants
import { isGuestSelector } from '../../../user/currentUserSelector';
import LinkButton from '../../buttons/LinkButton';

type Props = {
    error: object;
};

/**
 * This component is intended to be used when an unknown / unhandled error occurs.
 * For example we already handle the board timeout issue, but if we didn't then this modal would be defaulted to.
 */
const UnknownErrorContent: React.FC<Props> = ({ error }) => {
    const isGuest = useSelector(isGuestSelector);

    const dispatch = useDispatch();

    useEffect(() => {
        manuallyReportError({
            error,
            sensitive: false,
        });
    }, []);

    const code = prop('code', error) || prop('status', error) || 'UNKNOWN_ERROR';

    const guestActions = [
        {
            text: 'Log in',
            func: (event: Event) => {
                event.preventDefault();
                dispatch(navigateToLogin());
            },
        },
    ];
    const actions = isGuest ? guestActions : [];

    return (
        <>
            <h2>Something went wrong</h2>
            <div>
                <p>
                    We apologise for the inconvenience, the error has been logged and we&apos;ll try to resolve it soon.
                </p>
                <p>Please try again later.</p>
                <ModalActionsList actions={actions} />
            </div>
            <div className="section">
                <p>
                    Need help? <LinkButton onClick={() => dispatch(intercomShowMessages())}>Contact support</LinkButton>
                </p>
            </div>
            <p className="info">
                Error code: <strong>{code}</strong>
            </p>
        </>
    );
};

export default UnknownErrorContent;
